module.exports = __webpack_public_path__ + "static/media/Group15.16137d1b.svg";